const accessUsers = {

    PROFILE: { name: 'Profile', path: '/profile' },
    UPDATE_PROFILE: { name: 'Update Profile', path: '/update-profile' },

    USER_LIST: { name: 'User', path: '/user-list' },
    ADD_USER: { name: 'Add User', path: '/create-user' },
    UPDATE_USER: { name: 'Update User', path: '/edit-user' },
    DELETE_USER: { name: 'Delete User', path: '/delete-user' },
    USER_DETAILS: { name: 'User Details', path: '/user-details' },

    ASSIGN_PREMISES: { name: 'Asign Primises', path: '/asign-primises' },
    EDIT_PREMISES: { name: 'Edit Primises', path: '/edit-primises' },
    DELETE_PREMISES: { name: 'Delete Primises', path: '/delete-primises' },

    PREMISE_USER_LIST: { name: 'Premise User', path: '/premise-user-list' },
    ADD_PREMISE_USER: { name: 'Add Premise User', path: '/create-premise-user' },
    UPDATE_PREMISE_USER: { name: 'Update Premise User', path: '/edit-premise-user' },
    DELETE_PREMISE_USER: { name: 'Delete Premise User', path: '/delete-premise-user' },
    PREMISE_USER_DETAILS: { name: 'Premise User Details', path: '/premise-user-details' },
    BULK_UPLOAD_RESIDENT: { name: 'Bulk Upload Resident', path: '/bur' },
    DOWNLOAD_SAMPLE_FILE: { name: 'Download Sample File', path: '/dsf' },

    SERVICE_PROVIDER_LIST: { name: 'Service Provider', path: '/service-provider-list' },
    ADD_SERVICE_PROVIDER: { name: 'Add Service Provider', path: '/create-service-provider' },
    UPDATE_SERVICE_PROVIDER: { name: 'Update Service Provider', path: '/edit-service-provider' },
    DELETE_SERVICE_PROVIDER: { name: 'Delete Service Provider', path: '/delete-service-provider' },
    SERVICE_PROVIDER_DETAILS: { name: 'Service Provider Details', path: '/service-provider-details' },

    STAFF_ATTENDANCE_LIST: { name: 'Staff Attendance', path: '/staff-attendance-list' },
    STAFF_CALENDAR: { name: 'Staff Calendar', path: '/staff-calendar' },

    PREMISE_USER_ATTENDANCE_LIST: { name: 'Premise User Attendance', path: '/premise-user-attendance-list' },
    PREMISE_USER_CALENDAR: { name: 'Premise User Calendar', path: '/premise-user-calendar' },

    CHANGE_REQUEST_LIST: { name: 'Change Request', path: '/change-request-list' },
    CHANGE_REQUEST_APPROVAL: { name: 'Change Request Approval', path: '/change-request-approval' },

    FAMILY_MEMBER_LIST: { name: 'Family Member', path: '/family-member-list' },
    ADD_FAMILY_MEMBER: { name: 'Add Family Member', path: '/create-family-member' },
    UPDATE_FAMILY_MEMBER: { name: 'Update Family Member', path: '/edit-family-member' },
    DELETE_FAMILY_MEMBER: { name: 'Delete Family Member', path: '/delete-family-member' },

    XPRESS_ADMINS: { name: 'Xpress Admins', path: '/xpress-admins' },
    STAFF_MANAGEMENT: { name: 'Staff Management', path: '/staff-management' },
    PAYROLL_SUMMARY: { name: 'Payroll Summary', path: '/payroll-summary' },
    PAYROLL_SUMMARY_DETAIL: { name: 'Payroll Summary Details', path: '/payroll-summary-details' },
    ROLE_AND_USER: { name: 'Roles & Users', path: '/roles-and-users' },
    EXPRESS_ADMIN_ROLES_USERS: { name: 'Express Admin Roles & Users', path: '/express-admin-roles-users' },
}

export default accessUsers;